// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "svg[data-v-12ea0a74]{width:20%;margin-left:-15px;margin-top:-3px}svg .st01[data-v-12ea0a74]{fill:#707070}", ""]);
// Exports
module.exports = exports;
